"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityTypeFor = void 0;
var entityTypeFor = function (entity) {
  if (!entity) {
    return 'Entity';
  }
  return (entity.__typename || '').replace('API_', '');
};
exports.entityTypeFor = entityTypeFor;